/* eslint-disable @typescript-eslint/no-explicit-any */
export interface IFormat {
  format: any;
  formatDispatch: any;
}

export enum AttioQueryKeys {
  USER_RECORD_ID = 'attio-user-record-id',
  NOTES = 'attio-notes',
  VALUATION_ITEM = 'attio-valuation-item',
  VALUATION_STATUS_OPTIONS = 'attio-valuation-status-options',
  CURRENT_VALUATIONS = 'attio-current-valuations',
  PAST_VALUATIONS = 'attio-past-valuations',
  VALUATIONS = 'attio-valuations',
  VALUATIONS_ALL = 'valuations-all',
  VALUATIONS_BATCH = 'valuations-batch',
  ADDITIONAL_DATA = 'additional-data',
  DEAL_STAGE_OPTIONS = 'deal-stage-options',
  OTHER_CONSULTANT = 'attio-other-consultant',
  ENGAGEMENT_MANAGER = 'attio-engagement-manager',
  VALUATION_LEAD = 'attio-valuation-lead',
  VALUATION_LEAD_RECORD_ID = 'attio-valuation-lead-record-id',
  VALUATION_DATE = 'attio-valuation-date',
  ENGAGEMENT_TYPE = 'attio-engagement-type',
  BULK_NOTES = 'attio-bulk-notes',
}
